"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _rcDrawer = _interopRequireDefault(require("rc-drawer"));

require("../../../css/rc-drawer/assets/index.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default(props) {
  var _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      _props$width = props.width,
      width = _props$width === void 0 ? "25rem" : _props$width,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? "left" : _props$placement,
      children = props.children,
      onClose = props.onClose;
  return /*#__PURE__*/_react["default"].createElement(_rcDrawer["default"], {
    open: open,
    width: width,
    height: "100%",
    placement: placement,
    onClose: onClose,
    handler: false,
    level: null
  }, children);
};

exports["default"] = _default;
module.exports = exports["default"];